import { useState } from "react";
import FeedbackProviderContext from "./FeedbackProviderContext";

interface Props {
  children: React.ReactNode;
}

export default function FeedbackProviderContextWrapper({ children }: Props) {
  const [showModal, setShowModal] = useState(false);
  const [feedback, setFeedback] = useState<string | undefined>();

  return (
    <FeedbackProviderContext.Provider
      value={{
        showModal,
        setShowModal,
        feedback,
        setFeedback,
      }}
    >
      {children}
    </FeedbackProviderContext.Provider>
  );
}
